import type { SxProps, Theme } from "@mui/material";

export const formStyle: SxProps = (theme: Theme) => ({
  background: theme.palette.box1.main,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,
  p: 2,
  mb: 4,

  "& .MuiOutlinedInput-root": {
    width: "380px",
  },
});

export const formRowStyle: SxProps = () => ({
  mb: 4,
});

export const multiSelectorStyle: SxProps = () => ({});

export const checkboxValueStyle: SxProps = () => ({
  minWidth: "200px",
  fontSize: "14px",
  color: "#000000",
});
